import React, { createContext, FC, PropsWithChildren, useMemo } from "react";

import ScreenKeyboardModal from "@components/screenKeyboard";
import { IScreenKeyboardOptions } from "@components/screenKeyboard/screenKeyboard.types";

import { useScreenKeyboardState } from "./useScreenKeyboardState";

interface ScreenKeyboardContextProps {
  openKeyboard: (
    initialValue: string,
    onApply: (value: string) => void,
    options?: IScreenKeyboardOptions
  ) => void;
  closeKeyboard: VoidFunction;
}

export const ScreenKeyboardContext =
  createContext<ScreenKeyboardContextProps | null>(null);

const ScreenKeyboardProvider: FC<PropsWithChildren> = ({ children }) => {
  const {
    isOpen,
    value,
    variant,
    pattern,
    shiftFirst,
    suggestions,
    setValue,
    openKeyboard,
    closeKeyboard,
    applyKeyboard,
  } = useScreenKeyboardState();

  const contextValue = useMemo(
    () => ({ openKeyboard, closeKeyboard }),
    [openKeyboard, closeKeyboard]
  );

  return (
    <ScreenKeyboardContext.Provider value={contextValue}>
      {children}
      {isOpen && (
        <ScreenKeyboardModal
          value={value}
          variant={variant}
          pattern={pattern}
          shiftFirst={shiftFirst}
          suggestions={suggestions}
          onChange={setValue}
          onCancel={closeKeyboard}
          onEnter={applyKeyboard}
        />
      )}
    </ScreenKeyboardContext.Provider>
  );
};

export default ScreenKeyboardProvider;
